/* Black Friday lander: countdown, copy code, Ajax add to cart with automatic discount, sticky cart bar */
(function () {
  if (window.__bfInit) return;
  window.__bfInit = true;
  var DEFAULT_CODE = 'BLACKFRIDAY';
  var applied = {};
  var cartState = null;

  function pad(n) { return String(n).padStart(2, '0'); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function bar() { return document.querySelector('[data-bf-bar]'); }
  function drawer() { return document.querySelector('cart-drawer'); }
  function getCode() {
    var el = document.querySelector('[data-bf-code]');
    var c = el && el.getAttribute('data-bf-code');
    return (c && c.trim()) || DEFAULT_CODE;
  }

  function tick() {
    var now = Date.now();
    var nodes = document.querySelectorAll('[data-bf-countdown]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var t = Date.parse(el.getAttribute('data-bf-countdown'));
      if (isNaN(t)) continue;
      var ms = Math.max(0, t - now);
      var v = { d: Math.floor(ms / 864e5), h: Math.floor(ms / 36e5) % 24, m: Math.floor(ms / 6e4) % 60, s: Math.floor(ms / 1e3) % 60 };
      if (el.hasAttribute('data-bf-days-only')) { el.textContent = v.d; continue; }
      ['d', 'h', 'm', 's'].forEach(function (k) {
        var n = el.querySelector('[data-bf-' + k + ']');
        if (n) n.textContent = pad(v[k]);
      });
    }
  }

  function toast(html) {
    var old = document.querySelector('.bf-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'bf-toast';
    el.setAttribute('role', 'status');
    el.innerHTML = html;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 300);
    }, 2600);
  }

  function applyDiscount(code) {
    if (!code || applied[code]) return Promise.resolve();
    applied[code] = true;
    return fetch('/discount/' + encodeURIComponent(code) + '?redirect=%2Fcart.js', { credentials: 'same-origin' })
      .catch(function () { applied[code] = false; });
  }

  function parseSection(html, sel) {
    try {
      var n = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
      return n ? n.innerHTML : null;
    } catch (e) { return null; }
  }

  function refreshDrawerSilently(data) {
    var d = drawer();
    if (!data || !data.sections) return;
    var html;
    var cd = document.getElementById('CartDrawer');
    if (cd && data.sections['cart-drawer'] && (html = parseSection(data.sections['cart-drawer'], '#CartDrawer')) !== null) cd.innerHTML = html;
    var bub = document.getElementById('cart-icon-bubble');
    if (bub && data.sections['cart-icon-bubble'] && (html = parseSection(data.sections['cart-icon-bubble'], '.shopify-section')) !== null) bub.innerHTML = html;
    if (d) {
      d.classList.remove('is-empty');
      var inner = d.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
      var ov = d.querySelector('#CartDrawer-Overlay');
      if (ov && d.close) ov.addEventListener('click', d.close.bind(d));
    }
  }

  function openCart(trigger) {
    var d = drawer();
    if (d && typeof d.open === 'function') d.open(trigger);
    else window.location.href = '/cart';
  }

  function scrollToShop() {
    var b = bar();
    var link = b ? b.getAttribute('data-cta-link') : '';
    if (link && link.charAt(0) === '#') {
      var el = document.getElementById(link.slice(1));
      if (el) { window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' }); return; }
    }
    if (link) window.location.href = link;
  }

  function updateBar(cart) {
    cartState = cart;
    var b = bar();
    if (!b || !cart) return;
    var q = function (s) { return b.querySelector(s); };
    var count = cart.item_count, total = cart.total_price;
    var th = Number(b.getAttribute('data-threshold') || 0);
    var kick = q('[data-bf-kick]'), val = q('[data-bf-val]'), cta = q('[data-bf-cta]'), ship = q('[data-bf-ship]');
    if (count > 0) {
      kick.textContent = count + (count > 1 ? ' items' : ' item') + ' \u00b7 ' + (b.getAttribute('data-view-label') || 'View cart');
      val.textContent = money(total);
      cta.textContent = b.getAttribute('data-checkout-label') || 'Checkout';
      cta.setAttribute('href', '/checkout?discount=' + encodeURIComponent(getCode()));
      cta.removeAttribute('data-bf-shop');
    } else {
      kick.textContent = b.getAttribute('data-kick') || '';
      val.textContent = b.getAttribute('data-val') || '';
      cta.textContent = b.getAttribute('data-cta-label') || '';
      cta.setAttribute('href', b.getAttribute('data-cta-link') || '/collections/all');
      cta.setAttribute('data-bf-shop', '');
    }
    if (ship) {
      if (count > 0 && th > 0) {
        var left = th - total;
        ship.hidden = false;
        q('[data-bf-msg]').textContent = left > 0 ? 'You\u2019re ' + money(left) + ' away from free shipping' : 'You unlocked free shipping';
        q('[data-bf-fill]').style.width = Math.min(100, (total / th) * 100) + '%';
      } else {
        ship.hidden = true;
      }
    }
  }

  function loadCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateBar(c); return c; })
      .catch(function () { return null; });
  }

  document.addEventListener('click', function (e) {
    var copy = e.target.closest('[data-bf-copy]');
    if (copy) {
      e.preventDefault();
      var code = copy.getAttribute('data-bf-copy');
      try { navigator.clipboard.writeText(code); } catch (err) {}
      applyDiscount(code);
      var label = copy.textContent;
      copy.textContent = copy.getAttribute('data-copied') || 'Copied';
      setTimeout(function () { copy.textContent = label; }, 2000);
      return;
    }
    var sum = e.target.closest('[data-bf-sum]');
    if (sum) {
      e.preventDefault();
      if (cartState && cartState.item_count > 0) openCart(sum); else scrollToShop();
      return;
    }
    var shop = e.target.closest('[data-bf-shop]');
    if (shop && (shop.getAttribute('href') || '').charAt(0) === '#') {
      e.preventDefault();
      scrollToShop();
      return;
    }
    var btn = e.target.closest('[data-bf-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';
    var orig = btn.innerHTML;
    btn.innerHTML = btn.getAttribute('data-loading-text') || 'Adding...';
    btn.setAttribute('disabled', 'disabled');
    var b = bar();
    var openOnAdd = b ? b.hasAttribute('data-open-drawer') : true;

    applyDiscount(getCode()).then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(id), quantity: Number(btn.getAttribute('data-quantity') || 1) }],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        })
      });
    }).then(function (r) { return r.json(); }).then(function (data) {
      if (data && data.status && data.status !== 200) throw new Error(data.description || data.message || 'Sorry, that could not be added.');
      var d = drawer();
      var opened = false;
      if (openOnAdd && d && typeof d.renderContents === 'function' && data.sections) { d.renderContents(data); opened = true; }
      else refreshDrawerSilently(data);
      btn.innerHTML = btn.getAttribute('data-success-text') || 'Added to cart';
      setTimeout(function () { btn.innerHTML = orig; }, 2400);
      return loadCart().then(function (c) {
        if (opened) return;
        var th = b ? Number(b.getAttribute('data-threshold') || 0) : 0;
        var msg = 'Added to cart';
        if (c && th) {
          var left = th - c.total_price;
          msg = left > 0 ? 'Added \u00b7 ' + money(left) + ' from free shipping' : 'Added \u00b7 You unlocked free shipping';
        }
        toast(msg);
      });
    }).catch(function (err) {
      btn.innerHTML = orig;
      var span = document.createElement('span');
      span.textContent = (err && err.message) || 'Sorry, that could not be added.';
      toast(span.innerHTML + ' \u00b7 <a href="/cart">View cart</a>');
    }).then(function () {
      btn.removeAttribute('disabled');
      btn.dataset.busy = '0';
    });
  });

  function boot() {
    tick();
    setInterval(tick, 1000);
    loadCart();
    var pre = document.querySelector('[data-bf-apply-on-load]');
    if (pre) applyDiscount(getCode());
    var d = drawer();
    if (d && window.MutationObserver) {
      var wasOpen = d.classList.contains('active');
      new MutationObserver(function () {
        var isOpen = d.classList.contains('active');
        if (wasOpen && !isOpen) loadCart();
        wasOpen = isOpen;
      }).observe(d, { attributes: true, attributeFilter: ['class'] });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
